import { render, staticRenderFns } from "./invoice.vue?vue&type=template&id=56e93d5c&scoped=true"
import script from "./invoice.vue?vue&type=script&lang=js"
export * from "./invoice.vue?vue&type=script&lang=js"
import style0 from "./invoice.vue?vue&type=style&index=0&id=56e93d5c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e93d5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56e93d5c')) {
      api.createRecord('56e93d5c', component.options)
    } else {
      api.reload('56e93d5c', component.options)
    }
    module.hot.accept("./invoice.vue?vue&type=template&id=56e93d5c&scoped=true", function () {
      api.rerender('56e93d5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/flow/invoice.vue"
export default component.exports